import {  legacy_createStore } from "redux";

import appReducer from "./Reducer/Reducer";

export const store = legacy_createStore(appReducer);